import { RouterOutput } from "@mindlercare/mindlerapi-client";
import { SlotMethod } from "@mindlercare/schema";
import CONSTANTS from "core/constants";

const currentTwoDigitYear = new Date().getFullYear() % 100;

const bornIn21Century = (nationalIdentity: string) =>
  parseInt(nationalIdentity.substring(0, 2), 10) <=
  currentTwoDigitYear - CONSTANTS.MINIMUM_PATIENT_AGE;

export const formatNationalIdentitiy = (nationalIdentity: string) => {
  const natId = nationalIdentity.replace(/\D/g, "");
  if (natId.length === 10) {
    return bornIn21Century(natId) ? `20${natId}` : `19${natId}`;
  }
  return natId;
};

export const getSlotMethodFromBookingIntent = (
  defaultMethod: SlotMethod,
  bookingIntent: RouterOutput["psychologists"]["bookingIntent"],
): SlotMethod => {
  return bookingIntent.paymentMethods?.[0]?.slotMethods?.[0] || defaultMethod;
};
